module.exports = __webpack_public_path__ + "img/yoshinoya.05321e67.png";